module.exports = __webpack_public_path__ + "img/logo-2-small.50be06e6.svg";